export { default as silver } from './MapStyleSilver.json'
export { default as retro } from './MapStyleRetro.json'
export { default as taste } from './MapStyleTaste.json'
export { default as gray } from './MapStyleGray.json'
export { default as discreet } from './MapStyleDiscreet.json'
export { default as green } from './MapStyleGreen.json'
export { default as maroon } from './MapStyleMaroon.json'
